import { debounce, filter, Observable, timer } from 'rxjs';

// TODO: Consider approach to make the response more dynamic. e.g params of the validation
export namespace FormValidators {
  export const email = (value: string): Record<string, any> | null => {
    var re = /\S+@\S+\.\S+/;
    if (!re.test(value)) {
      return {
        not_valid_email: true,
      };
    }
    return null;
  };

  export const required = (value: string | undefined | null): Record<string, any> | null => {
    value = typeof value === 'string' ? value.trim() : value;

    if (value === '' || value === null || value === undefined) {
      return {
        required: true,
      };
    }
    return null;
  };

  export const mobile = (value: any): Record<string, any> | null => {
    value = value.trim();
    if (value.length === 0) return { number_empty: true };
    if (value.length > 11) {
      return {
        not_valid_length: true,
      };
    }
    const re = /^(\(?07\d{3}\)?)\s?\d{3}\s?\d{3}$/;
    if (!re.test(value)) {
      if (isNaN(value)) {
        return {
          not_valid_length: true,
        };
      } else {
        return {
          not_valid_mobile: true,
        };
      }
    }
    return null;
  };

  export const landline = (value: any): Record<string, any> | null => {
    value = value.trim();
    if (value.length === 0) return { number_empty: true };
    if (value.length > 11) {
      return {
        not_valid_length: true,
      };
    }
    const re = /^(?:0(?:1\d{8,9}|2\d{8,9}|3\d{8,9}))$/;
    if (!re.test(value)) {
      if (isNaN(value)) {
        return {
          not_valid_length: true,
        };
      } else {
        return {
          not_valid_landline: true,
        };
      }
    }
    return null;
  };
}

export function formValidationGenerator(
  individualFieldValidators: Record<string, ((value: any) => Record<string, any> | null)[]>,
  formValidators: ((value: Record<string, any>) => Record<string, any> | null)[] = [],
  options: Partial<{ debounceTimer: number }> = {},
  step?: string
) {
  return function (source: Observable<Record<string, any>>): Observable<{
    isFormValid: boolean;
    errors: Record<string, Record<string, any>>;
    formValue: Record<string, any>;
  }> {
    return new Observable((subscriber) => {
      return source
        .pipe(debounce(() => timer(options.debounceTimer ?? 0)))
        .pipe(filter((v) => !!v))
        .subscribe({
          next: (formValue: Record<string, any>) => {
            let errors: Record<string, Record<string, any>> = {};
            Object.keys(individualFieldValidators).forEach((key) => {
              individualFieldValidators[key].forEach((validator: (val: any) => any) => {
                const response = validator(formValue[key]);

                if (response === null) return;

                if (!errors[key]) {
                  errors[key] = {};
                }

                errors[key] = {
                  ...errors[key],
                  ...response,
                };
              });
            });

            // remove errors if either mobile or landline is present and the other textbox is empty
            if (step === 'confirm-your-details') {
              if (errors?.['mobile']) {
                if (
                  errors?.['mobile']?.['number_empty'] &&
                  !Object.values(errors?.['landline'] ?? {}).includes('number_empty')
                ) {
                  delete errors['mobile'];
                }
              }
              if (errors?.['landline']) {
                if (
                  errors?.['landline']?.['number_empty'] &&
                  !Object.values(errors?.['mobile'] ?? {}).includes('number_empty')
                ) {
                  delete errors['landline'];
                }
              }
            }

            formValidators.forEach((validator) => {
              const response = validator(formValue);

              if (response === null) return;

              if (!errors['section']) {
                errors['section'] = {};
              }

              errors['section'] = {
                ...errors['section'],
                ...response,
              };
            });

            subscriber.next({
              isFormValid: Object.keys(errors).length === 0,
              errors,
              formValue,
            });
          },
        });
    });
  };
}
